import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommentResolved = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 20,
		rx: 4,
		fill: "#5CDBD3",
		fillOpacity: .18
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.2 5H14.8C15.46 5 16 5.52595 16 6.16877V15.512C16 15.9459 15.4614 16.1632 15.1464 15.8564L13.8929 14.6355C13.7054 14.4528 13.451 14.3502 13.1858 14.3502H5.2C4.54 14.3502 4 13.8242 4 13.1814V6.16877C4 5.52595 4.54 5 5.2 5ZM13.1381 8.5434C13.3984 8.28982 13.3984 7.8787 13.1381 7.62512C12.8777 7.37155 12.4556 7.37155 12.1953 7.62512L9.66667 10.0879L8.13807 8.5991C7.87772 8.34553 7.45561 8.34553 7.19526 8.5991C6.93491 8.85268 6.93491 9.2638 7.19526 9.51738L9.19526 11.4653C9.45561 11.7189 9.87772 11.7189 10.1381 11.4653L13.1381 8.5434Z",
		fill: "#5CDBD3"
	})]
});
const ForwardRef = forwardRef(SvgCommentResolved);
export { ForwardRef as ReactComponent };
